import React from 'react';
import { BookOpenIcon, TrendingUpIcon } from 'lucide-react';
export function WhyParticipateSection() {
  return <section className="py-20 bg-white" data-id="element-288">
      <div className="container mx-auto px-4" data-id="element-289">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-290">
          <div data-id="element-291">
            <div className="inline-flex items-center px-3 py-1.5 bg-purple-100 rounded-full mb-4" data-id="element-292">
              <span className="text-purple-700 font-medium" data-id="element-293">Why Join Us</span>
            </div>
            <h2 className="text-3xl font-bold mb-4" data-id="element-294">📣 Why Participate?</h2>
            <div className="w-16 h-1 bg-gradient-to-r from-purple-500 to-blue-500 mb-6" data-id="element-295"></div>
            <p className="text-lg text-purple-700 font-medium mb-4" data-id="element-296">
              Join the Testbed Schools Initiative to collaborate with Eedi in
              enhancing maths education.
            </p>
            <p className="text-gray-700 mb-6 leading-relaxed" data-id="element-297">
              Your school will help identify impactful features, gain early
              access to new tools, and contribute to valuable research shaping
              Eedi's future.
            </p>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 mb-6" data-id="element-298">
              <div className="bg-purple-50 p-5 rounded-lg shadow-sm hover:shadow-md transition-all duration-300 border border-purple-100 transform hover:translate-y-[-4px]" data-id="element-299">
                <div className="flex items-center mb-3" data-id="element-300">
                  <div className="w-10 h-10 rounded-full bg-purple-100 flex items-center justify-center mr-3" data-id="element-301">
                    <TrendingUpIcon className="w-5 h-5 text-purple-600" data-id="element-302" />
                  </div>
                  <h3 className="font-medium" data-id="element-303">Impact Research</h3>
                </div>
                <p className="text-gray-600" data-id="element-304">
                  Help shape the future of educational technology through your
                  feedback and real-world implementation.
                </p>
              </div>
              <div className="bg-blue-50 p-5 rounded-lg shadow-sm hover:shadow-md transition-all duration-300 border border-blue-100 transform hover:translate-y-[-4px]" data-id="element-305">
                <div className="flex items-center mb-3" data-id="element-306">
                  <div className="w-10 h-10 rounded-full bg-blue-100 flex items-center justify-center mr-3" data-id="element-307">
                    <BookOpenIcon className="w-5 h-5 text-blue-600" data-id="element-308" />
                  </div>
                  <h3 className="font-medium" data-id="element-309">Early Access</h3>
                </div>
                <p className="text-gray-600" data-id="element-310">
                  Get exclusive access to cutting-edge features before they're
                  widely available and shape their development.
                </p>
              </div>
            </div>
          </div>
          <div className="flex justify-center" data-id="element-311">
            <div className="relative" data-id="element-312">
              <div className="absolute -top-4 -left-4 w-full h-full bg-gradient-to-br from-purple-200 to-blue-200 rounded-lg opacity-50 transform rotate-3" data-id="element-313"></div>
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/nnrPJN1T3tAAW91XEV99dY/Simplified_student_UI.png" alt="Student Interface" className="rounded-lg shadow-lg max-w-full h-auto relative z-10" data-id="element-314" />
            </div>
          </div>
        </div>
      </div>
    </section>;
}